import { Shell } from 'shared/components/Shell'

const SidebarShell = () => (
  <Shell width="100%" height={470} borderRadius="mega" />
)

export default SidebarShell
